var map = {
	"./About.vue": [
		"f820",
		"chunk-e9e1d72c"
	],
	"./Architecture.vue": [
		"a15c",
		"chunk-0264dfe6"
	],
	"./Contact.vue": [
		"f820",
		"chunk-e9e1d72c"
	],
	"./PageNotFound.vue": [
		"a5b5"
	],
	"./Photolab.vue": [
		"3837",
		"chunk-1f62dc52"
	],
	"./Projects.vue": [
		"acca",
		"chunk-03060b24"
	],
	"./Restoration.vue": [
		"29e7",
		"chunk-268a0c94"
	],
	"./Terms.vue": [
		"f820",
		"chunk-e9e1d72c"
	],
	"./Work.vue": [
		"f126"
	],
	"./Workshop.vue": [
		"fba8"
	],
	"./Workshops.vue": [
		"ad56",
		"chunk-1b9e0722"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;